import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { getSlotText } from '../../utils/getSlotText.js';
import 'reflect-metadata';

/**
 * Опция со слотами слева, по середине и справа
 * ```vue live
 <HseDropdownMenuBaseItem :style="{ textAlign: 'center' }">
 <template #left>
 Left
 </template>
 Center
 <template #right>
 Right
 </template>
 </HseDropdownMenuBaseItem>
 * ```
 */
var HseDropdownMenuBaseItem = /** @class */ (function (_super) {
    __extends(HseDropdownMenuBaseItem, _super);
    function HseDropdownMenuBaseItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseDropdownMenuBaseItem.prototype, "hasLineClamp", {
        get: function () {
            if (this.lineClamp === false)
                return false;
            return this.lineClamp > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseDropdownMenuBaseItem.prototype, "rootStyle", {
        get: function () {
            return this.hasLineClamp
                ? {
                    '--DropdownMenuBaseItem-line-clamp': String(this.lineClamp)
                }
                : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseDropdownMenuBaseItem.prototype, "title", {
        get: function () {
            var _a;
            return ((_a = this.$attrs.title) !== null && _a !== void 0 ? _a : (this.hasLineClamp ? getSlotText(this.$slots.default) : undefined));
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseDropdownMenuBaseItem.prototype, "selected", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseDropdownMenuBaseItem.prototype, "disabled", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseDropdownMenuBaseItem.prototype, "hovered", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseDropdownMenuBaseItem.prototype, "focused", void 0);
    __decorate([
        Prop({
            default: 2
        }),
        __metadata("design:type", Object)
    ], HseDropdownMenuBaseItem.prototype, "lineClamp", void 0);
    HseDropdownMenuBaseItem = __decorate([
        Component({
            name: 'HseDropdownMenuBaseItem'
        })
    ], HseDropdownMenuBaseItem);
    return HseDropdownMenuBaseItem;
}(Vue));

export default HseDropdownMenuBaseItem;
